import { jSith } from "../jquery-replacement";
import { S25ObjectUtil } from "./s25.object.util";
import { isDefined, isUndefined } from "./index";

export namespace S25Browser {
    export let isMobile: boolean | undefined = undefined;
    export const isIEBrowser: boolean = window.navigator.userAgent.match(/Trident\/|Edge\/|MSIE /) != null;

    // eslint-disable-next-line prefer-const
    export let isInIframe: boolean =
        (window.ProData && window.ProData.isInIframe) ||
        (function () {
            //eg, isEmbedded
            try {
                return window.self !== window.top;
            } catch (e) {
                return true;
            }
        })();

    export function setInIFrameClass(): void {
        if (isInIframe) {
            document.getElementById("s25")?.classList.add("inside-iframe");
        }
    }

    export function setDarkMode(isDark: boolean): void {
        if (isDark) {
            jSith.addClass("#s25", "nm-party--on");
            jSith.addAttr("#s25", "data-bs-theme", "dark");
            jSith.addClass("#themeTag", "nm-party--on");
            jSith.addAttr("#themeTag", "data-bs-theme", "dark");
        } else {
            jSith.removeClass("#s25", "nm-party--on");
            jSith.removeAttr("#s25", "data-bs-theme");
            jSith.removeClass("#themeTag", "nm-party--on");
            jSith.removeAttr("#themeTag", "data-bs-theme");
        }
    }

    let IsAppleMail: boolean | undefined;

    export function isAppleMail(): boolean {
        if (isDefined(IsAppleMail)) {
            return IsAppleMail;
        }

        const userAgentStr = window.navigator.userAgent;

        // https://github.com/ua-parser/uap-core/blob/master/regexes.yaml (yaml -> json; filtered to just AppleWebKit|Safari up until the Apple Mail entry)
        const userAgentParsers: any = [
            {
                regex: "AppleWebKit/\\d{1,10}\\.\\d{1,10}.{0,200} Safari.{0,200} (CreativeCloud)/(\\d+)\\.(\\d+).(\\d+)",
                family_replacement: "Adobe CreativeCloud",
            },
            {
                regex: "(?:Mobile Safari).{1,300}(OPR)/(\\d+)\\.(\\d+)\\.(\\d+)",
                family_replacement: "Opera Mobile",
            },
            {
                regex: "(rekonq)/(\\d+)\\.(\\d+)(?:\\.(\\d+)|) Safari",
                family_replacement: "Rekonq",
            },
            {
                regex: "AppleWebKit.{1,200} (NX)/(\\d+)\\.(\\d+)\\.(\\d+)",
                family_replacement: "NetFront NX",
            },
            {
                regex: "(iPod|iPhone|iPad).{1,200}Version/(\\d+)\\.(\\d+)(?:\\.(\\d+)|).{1,200}[ +]Safari",
                family_replacement: "Mobile Safari",
            },
            {
                regex: "(iPod|iPod touch|iPhone|iPad);.{0,30}CPU.{0,30}OS[ +](\\d+)_(\\d+)(?:_(\\d+)|).{0,30} AppleNews\\/\\d+\\.\\d+(?:\\.\\d+|)",
                family_replacement: "Mobile Safari UI/WKWebView",
            },
            {
                regex: "(iPod|iPhone|iPad).{1,200}Version/(\\d+)\\.(\\d+)(?:\\.(\\d+)|)",
                family_replacement: "Mobile Safari UI/WKWebView",
            },
            {
                regex: "(iPod|iPod touch|iPhone|iPad).{0,200} Safari",
                family_replacement: "Mobile Safari",
            },
            {
                regex: "(iPod|iPod touch|iPhone|iPad)",
                family_replacement: "Mobile Safari UI/WKWebView",
            },
            {
                regex: "(AppleWebKit)/(\\d+)(?:\\.(\\d+)|)\\+ .{0,200} Safari",
                family_replacement: "WebKit Nightly",
            },
            {
                regex: "(Version)/(\\d+)\\.(\\d+)(?:\\.(\\d+)|).{0,100}Safari/",
                family_replacement: "Safari",
            },
            {
                regex: "(Safari)/\\d+",
            },

            // Apple Mail - not directly detectable, have it after Safari stuff
            {
                regex: "(AppleWebKit)/(\\d+)\\.(\\d+)\\.(\\d+)",
                family_replacement: "Apple Mail",
            },
        ];

        for (let i = 0; i < userAgentParsers.length; i++) {
            const entry = userAgentParsers[i];
            const regex = new RegExp(entry.regex);
            const match = regex.exec(userAgentStr || "");
            if (match) {
                if (entry.family_replacement) {
                    if (entry.family_replacement.indexOf("$1") > -1) {
                        IsAppleMail = entry.family_replacement.replace(/\$1/, match[1]) === "Apple Mail";
                    } else {
                        IsAppleMail = entry.family_replacement === "Apple Mail";
                    }
                } else {
                    IsAppleMail = match[1] === "Apple Mail";
                }
                break;
            }
        }

        if (isUndefined(IsAppleMail)) {
            IsAppleMail = false;
        }

        return IsAppleMail;
    }

    export const isIENotEdge: boolean = window.navigator.userAgent.match(/Trident\/|MSIE /) != null;

    export const isPositionStickySupported: boolean = (function () {
        //used in s25-scroll-header
        const el = document.createElement("a"),
            mStyle = el.style;
        mStyle.cssText =
            "position:sticky;position:-webkit-sticky;position:-ms-sticky;position:-moz-sticky;position:-o-sticky;";
        return mStyle.position.indexOf("sticky") !== -1;
    })();
    export function mobileCheck(): boolean {
        if (typeof isMobile !== "undefined") {
            return isMobile;
        }

        //https://stackoverflow.com/questions/11381673/detecting-a-mobile-browser
        // check if browser is mobile
        let check: boolean = false;
        (function (a) {
            if (
                /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                    a,
                ) ||
                /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                    a.substr(0, 4),
                )
            )
                check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        isMobile = check;
        return isMobile;
    }

    export function postMessage(data: any): any {
        if (window.parent === window) return; // Don't send messages to yourself
        return window.parent?.postMessage(S25ObjectUtil.stringify(data), "*");
    }
    export function waitForElement(
        $elem: any,
        selector: string,
        ms?: number,
        maxTries?: number,
        tries: number = 0,
    ): any {
        ms = ms || 250;
        tries = tries || 0;

        if (maxTries && tries > maxTries) {
            // return jSith.reject(new Error("Element not found"));
            return window.angBridge.$q.reject(new Error("Element not found"));
        }

        let results: any[] = [];
        if (!$elem) {
            results = jSith.element(selector);
        } else {
            results = jSith.find($elem, selector);
        }

        if (results && results.length) {
            // return jSith.resolve(results);
            return window.angBridge.$q.when(results);
        } else {
            // return jSith.timeout(function() {
            return window.angBridge.$timeout(function () {
                tries++;
                return waitForElement($elem, selector, ms, maxTries, tries);
            }, ms);
        }
    }
    export function toBase64URI(base64: string, type: string): string {
        return "data:image/" + type + ";base64," + base64;
    }

    export function extractImageTypeFromURI(uri: string): string {
        return uri.substring(uri.indexOf("image/") + 6, uri.indexOf(";base64,"));
    }

    export function extractBase64FromURI(uri: string): string {
        return uri.replace(/^.*,/, ""); // Removes everything up to and including "base64,"
    }
    export function isIE(): boolean {
        return isIEBrowser;
    }

    export function isUnsupportedBrowser(): boolean {
        return isIENotEdge;
    }
    export function cloneElement(element: any) {
        const el = jSith.singleElement(element);
        return el && el.cloneNode(true);
    }

    export function simulateElememt(element: any, selectorsForStyleCopy?: string[]) {
        const jEl = jSith.singleElement(element);
        const el = cloneElement(jEl);
        if (el) {
            if (document.defaultView && document.defaultView.getComputedStyle) {
                el.style.cssText = document.defaultView.getComputedStyle(jEl, "").cssText || el.style.cssText;
            }

            // note: remove any element-set display style, so CSS display will be used instead (useful when element sets display: none)
            jSith.setCss(el, {
                display: "",
                "min-width": "0px",
                "min-height": "0px",
                position: "absolute !important",
                top: "-9999px !important",
                left: "-9999px !important",
                visibility: "hidden !important",
            });

            if (selectorsForStyleCopy && selectorsForStyleCopy.length) {
                jSith.forEach(selectorsForStyleCopy, function (_, selector) {
                    const subJEls = jSith.find(jEl, selector);
                    const subSimEls = jSith.find(el, selector);

                    jSith.forEach(subJEls, function (i, subJEl) {
                        const subSimEl = subSimEls[i];
                        if (subJEl && subSimEl && document.defaultView && document.defaultView.getComputedStyle) {
                            subSimEl.style.cssText =
                                document.defaultView.getComputedStyle(subJEl, "").cssText || subSimEl.style.cssText;
                        }
                    });
                });
            }

            jSith.append(document.body, el);
            return el;
        }
    }

    // clone element, append to body, measure dimensions, and remove from body
    export function measureElement(element: any): any {
        const el = simulateElememt(element);
        if (el) {
            const result = {
                offsetWidth: jSith.outerWidth(el),
                offsetHeight: jSith.outerHeight(el),
            };
            jSith.remove(el);
            return result;
        }
    }
    //cribbed from https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript
    //async is supported everywhere but IE and non-localhost http.
    export function copyToClipboard(text: string) {
        if (!navigator.clipboard) {
            const textArea = document.createElement("textarea");
            textArea.value = text;

            // Avoid scrolling to bottom
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.position = "fixed";

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                const successful = document.execCommand("copy");
                const msg = successful ? "successful" : "unsuccessful";
            } catch (err) {
                console.error("Fallback: Unable to copy", err);
                alert("The copy function failed to copy the text: " + text);
            }

            document.body.removeChild(textArea);
            return;
        }

        navigator.clipboard.writeText(text).then(
            function () {},
            function (err) {
                alert("The copy function failed to copy the text: " + text);
                console.error("Async: Could not copy text: ", err);
            },
        );
    }
    export function pageOffset(elem: HTMLElement) {
        const offset = {
            top: 0,
            left: 0,
        };
        while (elem) {
            offset.top += elem.offsetTop;
            offset.left += elem.offsetLeft;
            elem = elem.offsetParent as HTMLElement;
        }
        return offset;
    }

    // Finds the closest scrollable element
    export function getScrollableContainer(node: any): HTMLElement {
        if (!node || !(node instanceof HTMLElement)) return node;
        const overflowY = window.getComputedStyle(node).overflowY;
        const isScrollable = !(overflowY.includes("hidden") || overflowY.includes("visible"));
        if (isScrollable && node.scrollHeight >= node.clientHeight) return node;
        return getScrollableContainer(node.parentNode) || document.body;
    }
    export function isTextHighlight() {
        return (getSelection()?.toString() ?? "").length > 0;
    }
}
